import { createFileRoute } from '@tanstack/react-router';
import { ReplenishmentRunPage } from '@/features/inventory/ReplenishmentPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/replenishment/$runId')({
  component: Page,
});
function Page() {
  const { runId } = Route.useParams();
  return <ReplenishmentRunPage runId={runId} />;
}
